import React, { createContext } from 'react';

/**
 * @type {React.Context<{
 *   id: string,
 *   isMounted: boolean,
 *   onMount: () => void
 * }>}
 */
const TooltipContext = createContext();

export const TooltipProvider = TooltipContext.Provider;

export const useTooltip = () => {
  const context = React.useContext(TooltipContext);
  if (!context) {
    throw new Error('useTooltip must be used within a TooltipProvider');
  }
  return context;
};
